import "./order-collapse.scss";
import { Collapse } from "react-collapse";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import moment from "moment-timezone";
import { getBasePath } from "./../../helpers";
import { useEffect } from "react";

const rentPeriodStrategy = {
  'weekly_price': 'Semanal',
  'biweekly_price': 'Bi-Semanal',
  'monthly_price': 'Mensal',
  'bimonthly_price': 'Bimestral',
  'quarterly_price': 'Trimestral',
  'semiannual_price': 'Semestral',
  'yearly_price': 'Anual'
};

function OrderCollapse({ orderData, isPayment = false }) {
  const [isCollapsed, setIsCollapsed] = useState(true);
  const [totalPriceToys, setTotalPriceToys] = useState(0);
  const [totalPriceShipping, setTotalPriceShipping] = useState(0);
  const [totalPriceDiscount, setTotalPriceDiscount] = useState(0);

  const navigate = useNavigate();

  function handleCollapse() {
    setIsCollapsed(!isCollapsed);
  }

  function handleSendProof() {
    navigate(`/enviar-comprovante?order_id=${orderData.id}`);
  }

  useEffect(() => {
    if (!orderData || !orderData?.toys) return;
    const priceToys = orderData.toys.reduce((a, b) => {
      return a + parseFloat(b.pivot.price) * b.pivot.quantity;
    }, 0);

    setTotalPriceToys(priceToys);

    const priceDiscount = orderData.toys.reduce((a, b) => {
      return a + parseFloat(b.pivot.discount);
    }, 0);

    setTotalPriceDiscount(priceDiscount);
  }, []);

  if (!orderData) return null;

  return (
    <div className={"order-collapse bg-white rounded-3"}>
      <div className={"flex flex-row order-header p-4"}>
        <div>
          <h6 className={"fw-bold"}>PEDIDO</h6>
          <h5>{orderData.id}</h5>
        </div>
        <div>
          {!isPayment && (
            <>
              <h6 className={"fw-bold"}>STATUS</h6>
              <h6 className={"fw-bold"}>{orderData?.status?.description}</h6>
            </>
          )}
          {isPayment && (
            <>
              <h6 className={"fw-bold"}>PAGAMENTO</h6>
              <h6>Transferência</h6>
            </>
          )}
        </div>
        <div>
          <h6 className={"fw-bold"}>DATA</h6>
          <h6>{moment(orderData.updated_at).format("DD/MM/YYYY")}</h6>
        </div>
        <div>
          {!isPayment && (
            <button
              type="button"
              className="btn ms-2 order-details-btn is-order"
              onClick={() => handleCollapse()}
            >
              Detalhes do pedido
            </button>
          )}
          {isPayment && (
            <div>
              <button
                type="button"
                className="btn ms-2 order-details-btn is-payment mb-2 send-proof-btn"
                onClick={() => handleSendProof()}
              >
                Enviar comprovante
              </button>
              <button
                type="button"
                className="btn ms-2 order-details-btn is-payment"
                onClick={() => handleCollapse()}
              >
                Detalhes do pedido
              </button>
            </div>
          )}
        </div>
      </div>
      <Collapse isOpened={!isCollapsed}>
        <div className={"collapse-content-wrapper mx-4 pb-4"}>
          <div className={"col-12"}>
            <h6 className={"fw-bold mt-4"}>FORMA DE PAGAMENTO</h6>
            <h6>{orderData?.payment_type?.name}</h6>
          </div>
          {orderData?.address?.length > 0 ? (
            <div className={"col-12 mt-4"}>
              <h6 className={"fw-bold"}>ENDEREÇO PARA ENTREGA/COLETA</h6>
              <h6>
                {orderData.address[0].street}, {orderData.address[0].number}
              </h6>
              <h6>
                {orderData.address[0].district}, {orderData.address[0].city} -{" "}
                {orderData.address[0].state}
              </h6>
            </div>
          ) : null}
          <div className={"col-12 mt-4"}>
            <h6 className={"fw-bold"}>HISTÓRICO</h6>
            {orderData.histories.map((history) => (
              <div className={"gray-hover-row"}>
                <h6>{history.status.description}</h6>
                <h6>
                  {moment(history.date || history.created_at).format(
                    "DD/MM/YYYY HH:mm"
                  )}
                </h6>
              </div>
            ))}
          </div>
          {orderData?.toys?.length > 0 ? (
            <div className={"col-12 mt-4"}>
              <h6 className={"fw-bold"}>BRINQUEDOS</h6>
              {orderData.toys.map((toy) => (
                <div className={"toys-wrapper pt-3"}>
                  <img src={`${getBasePath()}/${toy.images[0].image}`} />
                  <div className={"px-3"}>
                    <h6 className={"fw-bold"}>{toy.name}</h6>
                    <div className={"toys-details"}>
                      <h6 className={"toys-details-row"}>
                        <span className={"fw-bold"}>Quantidade: </span>
                        {toy.pivot.quantity}
                      </h6>
                      <h6 className={"toys-details-row"}>
                        <span className={"fw-bold"}>Valor: </span>
                        R$ {toy.pivot.price}
                      </h6>
                      <h6 className={"toys-details-row"}>
                        <span className={"fw-bold"}>Desconto: </span>
                        R$ {toy.pivot.discount}
                      </h6>
                      <h6 className={"toys-details-row"}>
                        <span className={"fw-bold"}>Plano: </span>
                        {rentPeriodStrategy[toy.pivot.rent_period]}
                      </h6>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : null}
          <div className={"col-12 mt-4"}>
            <h6 className={"fw-bold"}>EXTRATO FINANCEIRO</h6>
            <div className={"gray-hover-row"}>
              <h6>TOTAL BRINQUEDOS</h6>
              <h6>+ R$ {totalPriceToys}</h6>
            </div>
            <div className={"gray-hover-row"}>
              <h6>TAXA DE FRETE</h6>
              <h6>+ R$ {totalPriceShipping}</h6>
            </div>
            <div className={"gray-hover-row"}>
              <h6>DESCONTO</h6>
              <h6>- R$ {totalPriceDiscount}</h6>
            </div>
            <div className={"order-total-wrapper"}>
              <h4>TOTAL DO PEDIDO</h4>
              <h4>
                R$ {totalPriceToys + totalPriceShipping - totalPriceDiscount}
              </h4>
            </div>
          </div>
        </div>
      </Collapse>
    </div>
  );
}

export default OrderCollapse;
